
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.902 4.483c.678.326 1.232.91 1.5 1.676a2.93 2.93 0 01-.125 2.245l1.114.537c.463-.963.56-2.103.18-3.19a4.16 4.16 0 00-2.13-2.382l-.539 1.114zm.941-1.951a5.084 5.084 0 012.601 2.912 5.092 5.092 0 01-.219 3.9l1.142.551c.707-1.47.855-3.21.274-4.871a6.345 6.345 0 00-3.247-3.635l-.551 1.143zm-8.655 9.89L4.334 7.328 1.77 8.26a2.702 2.702 0 00-1.603 3.47 2.703 2.703 0 003.458 1.626l2.564-.933zM1.184 11.36a1.619 1.619 0 01.956-2.08l1.544-.562 1.114 3.057-1.546.562a1.62 1.62 0 01-2.068-.977zm9.356-9.177l3.71 10.19c-3.024-.634-5.336-.648-7.043-.321l-.373-1.026c1.631-.342 3.559-.36 5.754-.048l-2.423-6.655c-1.485 1.66-2.947 2.86-4.438 3.66l-.374-1.027c1.498-.832 3.23-2.28 5.187-4.773zM8.598 15.86a1.82 1.82 0 01-.863-.631L6.44 13.492l-3.131 1.14 2.06 2.645c.233.296.629.41.981.281l2.274-.827a.46.46 0 00-.006-.864l-.019-.008zm-2.47.625L5.07 15.138l.984-.358 1.03 1.356-.957.349z","fill":"#fff"}})])
          )
        }
      }
    